import { FeaturesType } from "@utils/features";
import { ROOTS_DASHBOARD } from '../paths';
import { RouterProps } from '../types';
import { generateRoutes, generateRoutesNav } from '../generate-route';
import { paths } from './imports';

export const tables_routers = (): RouterProps => {
  const objectRoute = paths(ROOTS_DASHBOARD);
  const routes = generateRoutes(objectRoute);
  return routes;
};

export const tables_navigation = (rol: any, feature: FeaturesType[]) => {
  const objectRoute = paths(ROOTS_DASHBOARD);
  const routes = generateRoutesNav(objectRoute, rol, feature);
  return routes;
};
